import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup , Validators} from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  Column, GridOption, AngularGridInstance, AngularSlickgridComponent,
  OnEventArgs, GridStateChange, FieldType, Editors, Filters, EditorValidator, EditorArguments, Formatters, SlickGrid, GridService, SlickDataView, FlatpickrOption
} from 'angular-slickgrid';

import { Guid } from "guid-typescript";

import { IEDynamicItem, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { ColItem, HeaderItem, RowItem } from 'src/app/model/asd/asd-properties/asd-ie-type/asd-list';
import { InterfaceElementDataTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { GridCustomInputFilter } from 'src/app/model/grid/grid-properties/grid-custom/grid-customInputFilter';
import { CosyGridRowdetailViewComponent } from './cosy-grid-properties/cosy-grid-row/cosy-grid-rowdetail-view/cosy-grid-rowdetail-view.component';
import { CosyGridRowdetailPreloadComponent } from './cosy-grid-properties/cosy-grid-row/cosy-grid-rowdetail-preload/cosy-grid-rowdetail-preload.component';
import { GridColumnDefinition } from 'src/app/model/grid/grid';
import { FormMessage } from '../../model/form/form-properties/form-message';
import { GridCustomInputEditor } from 'src/app/model/grid/grid-properties/grid-custom/grid-customInputEditor';

import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { CosyHtmlElementGenerationService } from 'src/app/service/generator/generator-html/cosy-html-element-generation.service';
import { CosyCustomizedValidationService } from 'src/app/service/validator/cosy-customized-validation.service';
import { CosyFormGroupValidationService } from 'src/app/service/validator/cosy-form-group-validation.service';
import { MaskAttributes } from 'src/app/model/asd/asd-properties/asd-attribute';
import { cloneDeep } from 'lodash-es';
import { LocaleTypes } from 'src/app/model/locale/locale-type';
import { InterfaceElementAlignments } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-alignment';
import { timestamp } from 'rxjs/operators';


const cosyGridValidator: EditorValidator = (value: any, args?: EditorArguments) => {

  let formControl;
  let elementValidators = [];

  if(args.column['cosyDataTypeID']!= null ){
    elementValidators.push(CosyCustomizedValidationService.typeValidator(args.column['cosyDataTypeID']));
  }

  if(args.column['attributes'].Required){
    elementValidators.push(Validators.required);
  }

  if(args.column['attributes'].Min){
    elementValidators.push(CosyCustomizedValidationService.minValidator(args.column['attributes'].Min));
  }

  if(args.column['attributes'].Max){
    elementValidators.push(CosyCustomizedValidationService.maxValidator(args.column['attributes'].Max));
  }

  if (args.column['attributes'].Mask && args.column['attributes'].Mask.Pattern) {
    elementValidators.push(CosyCustomizedValidationService.maskValidator(new RegExp(args.column['attributes'].Mask.Pattern, 'i')));
  }

  formControl = new FormControl(value, [
    Validators.compose(elementValidators)   
     ]);
  
 
  let mReqIndex = args.column['messages'].map(function(e){return e.messageID}).indexOf(FormMessage.RequiredMessageID);
  let mNumIndex = args.column['messages'].map(function(e){return e.messageID}).indexOf(FormMessage.NumericValidatorMessageID);
  let mMinIndex = args.column['messages'].map(function(e){return e.messageID}).indexOf(FormMessage.MinValidatorMessageID);
  let mMaxIndex = args.column['messages'].map(function(e){return e.messageID}).indexOf(FormMessage.MaxValidatorMessageID);
  let mMaskIndex = args.column['messages'].map(function(e){return e.messageID}).indexOf(FormMessage.PatternValidatorMessageID);
  
  if(mReqIndex>-1 && formControl.errors!=null && formControl.errors.required){
    return { valid: false, msg: args.column['messages'][mReqIndex].messageText.replace('[label]',args.column.name) };
  }
  else if(mNumIndex>-1 && formControl.errors!=null && formControl.errors.numericDT){
    return { valid: false, msg: args.column['messages'][mNumIndex].messageText.replace('[label]',args.column.name) };
  }
  else if(mMinIndex>-1 && formControl.errors!=null && formControl.errors.minimum){
    return { valid: false, msg: args.column['messages'][mMinIndex].messageText.replace('[label]',args.column.name).replace('[min]',args.column['attributes'].Min) };
  }
  else if(mMaxIndex>-1 && formControl.errors!=null && formControl.errors.maximum){
    return { valid: false, msg: args.column['messages'][mMaxIndex].messageText.replace('[label]',args.column.name).replace('[max]',args.column['attributes'].Max) };
  }
  else if(mMaskIndex>-1 && formControl.errors!=null && formControl.errors.mask){
    return { valid: false, msg: args.column['messages'][mMaskIndex].messageText.replace('[label]',args.column.name).replace('[maskValue]',args.column['attributes'].Mask.Value) };
  }

  return { valid: true, msg: '' };
 
};


@Component({
  styles: ['.TableGreen { color: #008000 !important }  .TableRed {color: #FF0000  !important}  .TableYellow{color:  #FFC300  !important}'],
  encapsulation: ViewEncapsulation.None,
  selector: 'app-cosy-grid',
  templateUrl: './cosy-grid.component.html',
  styleUrls: ['./cosy-grid.component.css']
})

export class CosyGridComponent implements OnInit {
  @Input() ie: InterfaceElement;
  @Input() formgroup: FormGroup = null;
  @Output() dynaEditorNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBeforeGridDestroy = new EventEmitter<any>();
  @Output() onAfterGridDestroyed = new EventEmitter<boolean>();

  public gridId: any;
  public gridObj: any;
  public dataviewObj: any;
  public updatedObject: any;
  public validationErrorText: any = '';

  public emptyRowNotifyMessage: string;
  public paginationText: string;
  public deviceInfo = null;

  public isSingleSelect: boolean = true;
  public showHiddenHeaders: boolean = false;
  public isNonDesktopDevice: boolean = false;
  public isValidatorOn: boolean = false;

  public clientWidth: number = 0;
  public detailViewRowCount = 4;
  public gridWidth: number = 0;
  public autoRowNumber: number = 0;

  private pdfURL;

  public clickedColumn: any = [];
  public clickedRows: any = [];
  public selectedRows: any = [];
  public dataset: any[] = [];
  public editQueue : any[] = [];

  public pickedRowIDs: string[];
  public pickedRowDisplayNames: string[];
  public preValue: string[] = [];

  public pickedRowNumbers: number[];
  

  columnDefinitions: Column[] = [];
  updatedColumnDefinitions: Column[] = [];
  visibleHeaders: HeaderItem[] = [];

  private initIE: InterfaceElement;
  private resourceHeaderItem: HeaderItem;
  selectedColumn: Column;
  angularGrid: AngularGridInstance;
  gridOptions: GridOption = {};
  gridService!: GridService;
  grid!: SlickGrid;
  public rowCount: string;
  public pageCount: string;

  constructor(
    private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService,
    private cosyFormGroupValidationService: CosyFormGroupValidationService,
    private deviceService: DeviceDetectorService
  ) {
    this.gridId = Guid.create().toString();
  }


  ngOnInit() {
    this.initIE= cloneDeep(this.ie);
    this.pickedRowNumbers = [];
    this.pickedRowIDs = [];
    this.pickedRowDisplayNames = [];
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();

    if (isMobile) {
      this.isNonDesktopDevice = true;
    }

    this.formgroup = this.formgroup || new FormGroup({});
    if (this.ie.PostLabel != null) {
      this.rowCount = this.ie.Attributes.RowCount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");;
      this.pageCount = this.ie.Attributes.PageCount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      this.ie.PostLabel.DisplayName = this.ie.PostLabel.DisplayName.replace('%%A:RowCount%%', this.rowCount);
      this.ie.PostLabel.DisplayName = this.ie.PostLabel.DisplayName.replace('%%A:PageCount%%', this.pageCount);
      this.paginationText = this.ie.PostLabel.DisplayName;
    }

    if (this.ie.Label != null) {
      this.emptyRowNotifyMessage = this.ie.Label.DisplayName;
    }

    /*DEMO TRIAL FOR EDITOR FEATURE (text, picklist,date) */
    //  let currentVersionIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('CurrentVersion');
    //  this.ie.EntityList.HeaderItems[currentVersionIndex].Attributes.DisplayFormat = 4;

    /*if(this.ie.EntityList!= null && this.ie.EntityList.RowItems.length>0){
      let nameIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('DocumentDate');
      if(nameIndex>-1) { 
        this.ie.EntityList.HeaderItems[nameIndex].Attributes.DisplayFormat = 'MM/DD/YYYY';
        }
      }*/
      /*if(this.ie.EntityList!= null && this.ie.EntityList.RowItems.length>0){
      let nameIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('Name');
      if(nameIndex>-1) {
        this.ie.EntityList.HeaderItems[nameIndex].Attributes.Required = true;
      } 
      let modulescopeIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('ModuleScopeDID_DisplayName');
      if(modulescopeIndex>-1) 
      { 
        this.ie.EntityList.HeaderItems[modulescopeIndex].CosyDataTypeDID = '85755da6-b68b-41b5-a1e0-7d26bfe1b3d0';
      }
      let currentVersionIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('CurrentVersion');
      if(currentVersionIndex>-1) 
      { 
        this.ie.EntityList.HeaderItems[currentVersionIndex].Attributes.Required = true;
        this.ie.EntityList.HeaderItems[currentVersionIndex].Attributes.Min = 10;
        this.ie.EntityList.HeaderItems[currentVersionIndex].Attributes.Max = 50;
      }
      //adalbert.kramer@curry.de
      let displayNameIndex = this.ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf('DisplayName');
      if(displayNameIndex>-1) {
        this.ie.EntityList.HeaderItems[displayNameIndex].Attributes.Mask = new MaskAttributes();
        this.ie.EntityList.HeaderItems[displayNameIndex].Attributes.Mask.Pattern = '^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$';
        this.ie.EntityList.HeaderItems[displayNameIndex].Attributes.Mask.Value = 'adalbert.kramer@curry.de'
      }

      for(let r of this.ie.EntityList.RowItems){
        for(let c of r.ColItems){
          if(c.Name == 'IsCosyRegisteredComponent'){
            if(c.Value == 'False') c.Value = false;
            if(c.Value == 'True') c.Value = true;
          }
        }
      }

    }*/
    /**END DEMO TRIAL */

    if (this.ie.EntityList != null && this.ie.EntityList.HeaderItems.length > 0) {
      this.resourceHeaderItem = this.ie.EntityList.HeaderItems.find(headerItem => headerItem.CosyDataTypeDID == InterfaceElementDataTypes.ResorceDT);
      this.defineCosyGrid();
    }

    if (this.ie.Values != null && this.ie.Values.length > 0) {
      for (let value of this.ie.Values) {
        let dataIndex = this.dataset.map(function (e) { return e.id }).indexOf(value.Value);
        if (dataIndex > -1) {
          // this.angularGrid.gridService.setSelectedRows([dataIndex]);
        }
        else {
          let colIndex = this.columnDefinitions.map(function (e) { return e.name }).indexOf(value.Value);
          if (colIndex > 1) {
            this.selectedColumn = this.columnDefinitions[colIndex];
          }
        }
      }
    }
  }
  ngOnDestroy() {
    if (this.angularGrid != null) {
      this.onBeforeGridDestroy.emit(this.angularGrid);
      this.dataviewObj = this.angularGrid.dataView;
      this.destroyGrid();
      this.onAfterGridDestroyed.emit(true);
    }
  }
  ngDoCheck() {
    var div = document.getElementById('entityList');
    
    if (div != null) {
      if (this.clientWidth !== div.clientWidth && this.angularGrid != null) {
        this.angularGrid.resizerService.resizeGrid(0, { height: 200, width: div.clientWidth });
        this.clientWidth = div.clientWidth;
      }
    }
    if (this.uxControllerService.isDynaFunctionCompleted && this.uxControllerService.dynaReferenceIEID == this.ie.InterfaceElementID) {
     // this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, this.ie.Attributes.ActivePage, 'ActivePage', null, null, null, null);
      this.defineCosyGrid();
      this.uxControllerService.isDynaFunctionCompleted = false;
    }
  }

  
 
  updateItemMetadataForColoredRecords(previousItemMetadata: any) {

    return (rowNumber: number) => {
      const item = this.dataviewObj.getItem(rowNumber);
      let meta = {
        cssClasses: ''
      };
      if (typeof previousItemMetadata === 'object') {
        meta = previousItemMetadata(rowNumber);
      }

      if (meta && item && item.rowCSSClass) {
        meta.cssClasses = (meta.cssClasses || '') + ' ' + item.rowCSSClass;
      }

      return meta;
    };
  }

  defineCosyGrid() {

    this.visibleHeaders = [];
    let sortedColumnName = '';
    let sortOrder ='';

      sortedColumnName = this.ie.Attributes.SortOrder.substring(this.ie.Attributes.SortOrder.indexOf('[')+1, this.ie.Attributes.SortOrder.indexOf(']')).trim();
      sortOrder = this.ie.Attributes.SortOrder.substring(this.ie.Attributes.SortOrder.indexOf(']')+1, this.ie.Attributes.SortOrder.length).trim();

    if (this.ie.EntityList.HeaderItems != null && this.ie.EntityList.HeaderItems.length > 0) {
      for (let header of this.ie.EntityList.HeaderItems) {
        if (header.Attributes.Visible) {
          this.visibleHeaders.push(header);
        }
      }
    }

    if (this.ie.Attributes.OnMultiSelectUAID != null) {
      this.isSingleSelect = false;
    }

    if (this.ie.Values != null && this.ie.Values.length > 0) {
      for (let v = 0; v < this.ie.Values.length; v++) {
        this.preValue.push(this.ie.Values[v].Value);
        this.selectedRows.push(this.ie.Values[v].Value);
      }

    }

    if (this.preValue.length == 0) this.preValue.push("");
    if (this.selectedRows.length == 0) this.selectedRows.push("");

    this.visibleHeaders.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    this.columnDefinitions = [];

    let columnDefinition: GridColumnDefinition;

    let detailViewColumn: Column = {
      id: 'detailView',
      field: '',
      cssClass: "fas fa-align-justify ",
      headerCssClass: "myclass",
      width: 20,
      onCellClick: (e: Event, args: OnEventArgs) => {
        this.fetchIEUserAction(this.ie.Attributes.OnDetailUAID, args.dataContext['id'], null, null, null, null, null)
      }
    }

    let resourceViewerColumn: Column = {
      id: 'resourceView',
      field: '',
      cssClass: "fa fa-file-pdf-o",
      width: 20,
      onCellClick: (e: Event, args: OnEventArgs) => {
        this.downloadResource(args.dataContext['id'])
      }
    }
    if (this.ie.Attributes.OnDetailUAID != null) {
      this.columnDefinitions.push(detailViewColumn);
    }

    if (this.resourceHeaderItem != null) {
      this.columnDefinitions.push(resourceViewerColumn);
    }

    for (let header of this.visibleHeaders) {
   
      columnDefinition = new GridColumnDefinition()
      columnDefinition.attributes = header.Attributes;
      columnDefinition.id = header.Name;
      columnDefinition.name = header.DisplayName;
      columnDefinition.field = header.Name;
      columnDefinition.allowSort = header.AllowSorting;
      columnDefinition.messages = this.ie.Messages;      

      columnDefinition.cosyDataTypeID = header.CosyDataTypeDID;

      if(header.Attributes.Width!== null && header.Attributes.Width > 0){
        columnDefinition.minWidth = parseInt(header.Attributes.Width.toString());
      }
      else {
        
        if (header.CosyDataTypeDID == InterfaceElementDataTypes.GuidDT || header.SystemDataType == "System.Guid" || header.CosyDataTypeDID == '01717c8a-840f-409d-aa6a-55122c2ee9da' || header.CosyDataTypeDID == InterfaceElementDataTypes.LockUpItemDT) {
            columnDefinition.minWidth = 300;
  
        }
        if (header.CosyDataTypeDID == InterfaceElementDataTypes.IntegerDT || header.CosyDataTypeDID == InterfaceElementDataTypes.BooleanDT || header.CosyDataTypeDID == InterfaceElementDataTypes.DoubleDT) {
            columnDefinition.minWidth = (columnDefinition.name.length * 8) + 52;
            columnDefinition.formatter = Formatters.alignRight;
        }
        if (header.CosyDataTypeDID == InterfaceElementDataTypes.StringDT || header.CosyDataTypeDID == InterfaceElementDataTypes.DateDT || header.SystemDataType == "System.String") {
            columnDefinition.minWidth = this.calculateColumnWidth(header);
        }
      }


      if(header.Attributes.Alignment !== null){
        if(header.Attributes.Alignment == InterfaceElementAlignments.Left){}
        else if(header.Attributes.Alignment == InterfaceElementAlignments.Right) {columnDefinition.formatter = Formatters.alignRight;}
        else if(header.Attributes.Alignment == InterfaceElementAlignments.Middle) {columnDefinition.formatter = Formatters.alignCenter;}
      }

      

     

      /*Trial picklist Start*/
      /*if(header.Name == 'ModuleScopeDID_DisplayName'){
        header.CosyDataTypeDID = InterfaceElementDataTypes.PicklistDT;
      
      }
      if(header.CosyDataTypeDID == InterfaceElementDataTypes.PicklistDT){
        
        header.Items = [
          {
            "ID": "00000000-0000-0000-0000-000000000000",
            "DisplayName": "Bitte wählen...",
            "Visible": true
          },
          {
              "ID": "228682f4-164c-44a8-a8b5-3452167f7a74",
              "DisplayName": "CCO",
              "Visible": true
          },
          {
              "ID": "559912f1-f111-420a-8652-28828381b4a7",
              "DisplayName": "ACO",
              "Visible": true
          },
          {
              "ID": "4e3d096a-5671-40e1-9982-d8e71ed5065e",
              "DisplayName": "BCO",
              "Visible": true
          }
        ]
        columnDefinition.items = header.Items;
        columnDefinition.cosyDataTypeID = header.CosyDataTypeDID;
      }*/
      /*Trial picklist End*/
     
      if(header.Editable!= null && header.Editable == true){
        columnDefinition.allowEdit = true;

        if(header.CosyDataTypeDID == InterfaceElementDataTypes.StringDT ) {
          columnDefinition.type = FieldType.string,
          columnDefinition.editor =  {
          model: GridCustomInputEditor,
          placeholder: '',
          validator: cosyGridValidator,
          }
        }

        
        else if(header.CosyDataTypeDID == InterfaceElementDataTypes.IntegerDT ) {
          columnDefinition.type = FieldType.integer,
          columnDefinition.editor =  {
          model: GridCustomInputEditor,
          placeholder: '',
          validator: cosyGridValidator,
          }
        }

        else if(header.CosyDataTypeDID == InterfaceElementTypes.InputPicklist){
          columnDefinition.type =  FieldType.string;
          columnDefinition. editor =  {
               model: Editors.singleSelect,
               enableRenderHtml: true,
               /*collection: Array.from(Array(3).keys()).map(k => ({ value: k, label: k }))*/
               collection: header.Items.map(k => ({ value: k.DisplayName, label: k.DisplayName }))
           }
        }

        else if (header.CosyDataTypeDID == InterfaceElementDataTypes.DateDT){
          columnDefinition.onCellClick = function (e: Event, args: OnEventArgs) {
            // cellClick function can be processed here
          }
          columnDefinition.filterable = true,
          columnDefinition.type = FieldType.dateTimeEuro
          columnDefinition.editor =  {
            model: Editors.date,
            editorOptions: { enableTime: true , enableSeconds: true, time_24hr: true } as FlatpickrOption
          }
        }

        else if(header.CosyDataTypeDID == InterfaceElementDataTypes.BooleanDT){
          columnDefinition.type = FieldType.boolean,
          columnDefinition.filter=  {
            model: Filters.singleSelect,
            collection: [{ value: '', label: '' }, { value: true, label: 'True' }, { value: false, label: 'False' }],
          },
          columnDefinition.formatter = Formatters.checkmark,
          columnDefinition.editor = {
            model: Editors.checkbox,
          }
        }
      }

      if(header.Attributes.HyperLink !== null && typeof header.Attributes.HyperLink !== 'undefined'){
        let re = new RegExp(/%%/i,'gi');
        let calledHeaders = new Array();
        var results = new Array();
        while (re.exec(header.Attributes.HyperLink)){
           results.push(re.lastIndex);
        }
        
        for(let r=0; r<results.length; r+=2){
          calledHeaders.push(header.Attributes.HyperLink.substring(results[r], results[r+1]-2));
        }
        columnDefinition.hyperLinkValues = [];
       
        for(let r of this.ie.EntityList.RowItems){
          let hlvList: any = [];
          for(let c of r.ColItems){
            for(let ch of calledHeaders){
              if(c.Name == ch){
                let hlv = {LinkedHeader : c.Name, Value: c.Value};
                hlvList.push(hlv);
              }
            }
          }
          columnDefinition.hyperLinkValues.push(hlvList);
        }
        columnDefinition.formatter = function ( row, cell, value, columnDef, dataContext ) {
          let hyperLinkData = columnDef['hyperLinkValues'][row];
          let link = columnDef['attributes']['HyperLink'];
          for(let hld of hyperLinkData){
            link = link.replace('%%'+hld['LinkedHeader']+'%%', hld['Value']);
          }
         return '<a target="_blank" href="'+link+'">' + value + '</a>';
        }
      }
      this.columnDefinitions.push(columnDefinition);
    }

    for (let c of this.columnDefinitions) {
     
      let ascCSS = "fa fa-arrow-up header-plugin-assignment-asc";
      let descCSS = "fa fa-arrow-down header-plugin-assignment-desc";
      if(sortedColumnName !== '' && c.id == sortedColumnName){
    
        if(sortOrder.toLocaleUpperCase() == 'DESC') {
          descCSS = descCSS + '  root-color';
        }
        if(sortOrder.toLocaleUpperCase() == 'ASC' || sortOrder == '') {
          ascCSS = ascCSS + ' root-color';
        }
      }
     
      //allowEdit
      if(c.header == null){
        c.header = {};
        c.header.buttons = [];
      }
      if(c['allowEdit'] == true){
        c.header.buttons.push({
              cssClass: "fa fa-pencil-square-o header-plugin-assignment-edit",
              handler: (e) => {
              // this.highlightGridCell(c)
              }
           })
      }
      if(c['allowSort'] == true){
        c.header.buttons.push({
            cssClass: ascCSS,
            command: 'asc',
            handler: (e) => {
              this.sortGrid(c, 'asc')
          },
        });
        c.header.buttons.push({
            cssClass: descCSS,
            command: 'desc',
            handler: (e) => {
               this.sortGrid(c, 'desc')
            }
        });
      }   
    }

    this.gridOptions = {
      asyncEditorLoading: false,
      enableColumnPicker: false,
      enableExcelExport: false,
      autoEdit: true,
      autoCommitEdit: true,
      enableCellNavigation: true,
      enableMouseHoverHighlightRow: true,
      //enableTextSelectionOnCells: false,
      enableAutoResize:false,
      enableAutoSizeColumns: true,
      //gridWidth: 0,
      //forceFitColumns: true,
      autoHeight: true,
      
      
      // autoResize : (this.isNonDesktopDevice)?{calculateAvailableSizeBy: 'container'}: 
      //             { containerId: 'entityList',
      //             calculateAvailableSizeBy: 'container',
      //             maxWidth: this.clientWidth,
      //             sidePadding: 15,
      //             bottomPadding:15},
      // autoFitColumnsOnFirstLoad: true,
      // autosizeColumnsByCellContentOnFirstLoad: true,
      // enableAutoResizeColumnsByCellContent: true,
      // autoFitColumnsOnFirstLoad: true,
      // enableAutoSizeColumns: true,

      enableGridMenu: false,
      enableHeaderMenu: false,
      enableHeaderButton: true,
      enableRowSelection: true,
      enableFiltering: false,
      enableRowDetailView: this.isNonDesktopDevice,
      rowDetailView: {
        process: (item) => this.simulateServerAsyncCall(item),
        loadOnce: false,
        singleRowExpand: false,
        useRowClick: false,
        panelRows: this.detailViewRowCount,
        preloadComponent: CosyGridRowdetailPreloadComponent,
        viewComponent: CosyGridRowdetailViewComponent,
        parent: this
      },

      enableCheckboxSelector: this.ie.Attributes.OnMultiSelectUAID != null ? true : false,
      checkboxSelector: {
        hideSelectAllCheckbox: false
      },
      rowSelectionOptions: {
        selectActiveRow: this.isSingleSelect,
      },
      presets: {
        rowSelection: {
          dataContextIds: this.preValue
        }
      },
      // dataView: {
      //   syncGridSelection: false, // enable this flag so that the row selection follows the row even if we move it to another position
      // },
      editable: true,
      editCommandHandler: (item, column, editCommand) => {
        this.editQueue.push(editCommand);
        editCommand.execute();
      },
      /*editCommandHandler: (item, column, editCommand) => {
        this.editItems.push(item);
        this.editQueue.push(editCommand); // <-- last edit command
        editCommand.execute();
      },*/
    }
    this.getCosyGridData();
  }

  onValidationError(e: Event, args: any) {
    if (args.validationResults) {
      this.isValidatorOn = true;
      this.validationErrorText = args.validationResults.msg;
    }
  }

  onColumnResizing(e){
      let triggeredColumnID =  e.detail.args.triggeredByColumn;
      let triggeredIndex = e.detail.args.grid.getColumns().map(function(e){return e.id}).indexOf(triggeredColumnID)
      let newWidth = e.detail.args.grid.getColumns()[triggeredIndex].width;
      if(this.uxControllerService.isAdmin){
        this.uxControllerService.updateCASDFromUI(this.ie,triggeredColumnID, "Width", newWidth, this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument )
      }
  }


  getCosyGridData() {
    this.dataset = [];
    let i: number = 0;
    for (let row of this.ie.EntityList.RowItems) {
      const obj = {};
      if (row.ID != null && row.ID != "") {
        obj['id'] = row.ID;
        obj['displayName'] = row.DisplayName;
      }
      else obj['id'] = i++;
      let colItemDisplayScope = row.ColItems.find(element => element.Name == 'Cosy_DisplayScopeDID');
      if (colItemDisplayScope != null && this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.DisplayScope != null) {
        let keys = Object.keys(this.ie.CustomizeOptions.DisplayScope);
        let dsCssClass = this.ie.CustomizeOptions.DisplayScope[keys.find(element => element == colItemDisplayScope.Value)];
        if (dsCssClass != null) {
          obj['rowCSSClass'] = dsCssClass;
        }
      }
      for (let ci of row.ColItems) {
        
        let colIndex = this.columnDefinitions.map(function (e) { return e.id }).indexOf(ci.Name);
        if (colIndex > -1) {
          
          const datakey = ci.Name;
          if(ci.BaseValue == null) ci.BaseValue = ci.Value;
    
          if(this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.DoubleDT
                  || this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.DecimalDT
                  || this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.FloatDT
                  || this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.IntegerDT
                  || this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.LongDT
                  || this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.ShortDT){
                   
                if(this.columnDefinitions[colIndex]['attributes']['DisplayFormat']!= null){
                  
                  let allowedDecimalPlaces : number = 0;
                  let formattedValue;

                  if(this.columnDefinitions[colIndex]['attributes']['DisplayFormat']!= ''){
                    allowedDecimalPlaces =  parseInt(this.columnDefinitions[colIndex]['attributes']['DisplayFormat']);
                  }
                  
                  if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
                    formattedValue =  new Intl.NumberFormat(LocaleTypes.LocaleTypeDE_CODE, { minimumFractionDigits: allowedDecimalPlaces, maximumFractionDigits: allowedDecimalPlaces}).format(ci.BaseValue);
                    ci.Value = formattedValue;

                  }
                  else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){
                    formattedValue =  new Intl.NumberFormat(LocaleTypes.LocaleTypeEN_CODE, { minimumFractionDigits: allowedDecimalPlaces, maximumFractionDigits: allowedDecimalPlaces}).format(ci.BaseValue);
                    ci.Value = formattedValue; 
                    
                  }
                  obj[datakey] = ci.Value;
                }  
                else if(this.columnDefinitions[colIndex]['attributes']['DisplayFormat'] == null ||this.columnDefinitions[colIndex]['attributes']['DisplayFormat'] == '' ) {
                //  obj[datakey] = ci.Value;
                  if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
                    ci.Value = new Intl.NumberFormat(LocaleTypes.LocaleTypeDE_CODE).format(ci.Value)   
                  } 
                  else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){  
                    ci.Value = new Intl.NumberFormat(LocaleTypes.LocaleTypeEN_CODE).format(ci.Value)
                  }
                  obj[datakey] = ci.Value;
                }           
          } 
          else if(this.columnDefinitions[colIndex]['cosyDataTypeID'] == InterfaceElementDataTypes.DateDT){
            if(this.columnDefinitions[colIndex]['attributes']['DisplayFormat']!= null && ci.Value!= ''){
              obj[datakey] = this.cosyHtmlElementGenerationService.updateDateFormat(this.columnDefinitions[colIndex]['attributes']['DisplayFormat'],ci.Value);
            }

            else if(this.columnDefinitions[colIndex]['attributes']['DisplayFormat'] == null && ci.Value!= ''){
              if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
                let stampIndex = ci.Value.indexOf(':');
                let timeStamp = ci.Value.substring(stampIndex-2, ci.Value.length);
                obj[datakey] = this.cosyHtmlElementGenerationService.updateDateFormat('DD.MM.YYYY',ci.Value).concat(' '+timeStamp);
              }
              else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){
                obj[datakey] = ci.Value;
              }
            }
          }
          else {
            obj[datakey] = ci.Value;
          }
        }
      }

      this.dataset.push(obj);
    }
  }

  angularGridReady(angularGrid: AngularGridInstance) {
  
    let availableWidth: number = 0;
    let div = document.getElementById('entityList');

    this.angularGrid = angularGrid; 
    this.dataviewObj = angularGrid.dataView;
    this.gridObj = angularGrid.slickGrid as SlickGrid;
    this.gridService = angularGrid.gridService;   
    this.gridWidth = this.angularGrid.slickGrid.getCanvasWidth();
    this.dataviewObj.getItemMetadata = this.updateItemMetadataForColoredRecords(this.dataviewObj.getItemMetadata);  
    this.gridObj.invalidate();
    this.gridObj.render();

    this.uxControllerService.autoGridRowHeight = this.angularGrid.slickGrid.getOptions().rowHeight;   
    /*var rowHeight = this.angularGrid.slickGrid.getOptions().rowHeight;
    var rowsHeight= 0;
    var calcRowNumbers = 0;
    
    console.log('Inner browser height: ', window.innerHeight);
    console.log('screen available  height: ', screen.availHeight);
    console.log('Client Height: ', document.documentElement.clientHeight);
    
    //while(rowsHeight <= screen.availHeight){
    while(rowsHeight <= window.innerHeight){
      rowsHeight = rowsHeight + rowHeight;
      calcRowNumbers = calcRowNumbers + 1;
      this.autoRowNumber = this.autoRowNumber +1;
    }
    this.autoRowNumber = this.autoRowNumber-10;
    this.cosyCommunicationControllerService.autoGridRowNumbers = this.autoRowNumber;
    console.log('Auto Row numbers: ', this.cosyCommunicationControllerService.autoGridRowNumbers);*/
    

    if (this.isNonDesktopDevice) {
      let mediator: number = 0;
      const allColumns = this.angularGrid.gridService.getAllColumnDefinitions();
      if (div != null) {
        this.gridOptions.autoResize.maxWidth = div.clientWidth;
        this.angularGrid.resizerService.resizeGrid();
        let a_Columns = [];
        for (let col of allColumns) {
          availableWidth = availableWidth + col.minWidth;

          if (availableWidth <= div.clientWidth && col.minWidth !== -1) {
            col.width = col.minWidth;
            a_Columns.push(col);
            mediator = availableWidth;

          }
          if (availableWidth > div.clientWidth) {
            col.minWidth = -1;
            col.maxWidth = -1;
            col.width = -1;
          }
        }

        let ratio = div.clientWidth / mediator;
        let difference = div.clientWidth - mediator;
        let a = allColumns[a_Columns.length - 1].minWidth + difference;

        allColumns[a_Columns.length - 1].minWidth = a;
        allColumns[a_Columns.length - 1].maxWidth = a;
        allColumns[a_Columns.length - 1].width = a;
        this.updatedColumnDefinitions = allColumns;
      }
    }

    if (this.selectedColumn != null) {
      for (let c = 0; c < this.columnDefinitions.length; c++) {
        if (this.columnDefinitions[c].id == this.selectedColumn.id) {
          this.setRowsPerColClick(c, '#dae8f1');
        }
      }
    }

  }

  getDisplayNamesPerSelectedRows(rowIDs: any[]) {
    this.pickedRowIDs = rowIDs;
    let rowDataIndex: number = -1;
    for (let r of rowIDs) {
      rowDataIndex = this.dataset.map(function (e) { return e.id }).indexOf(r);
      if (rowDataIndex > -1) {
        this.pickedRowDisplayNames.push(this.dataset[rowDataIndex].displayName);
      }
    }
  }

  gridStateChanged(gridStateChanges: GridStateChange) {
    if (this.ie.Attributes.OnMultiSelectUAID != null && gridStateChanges['detail']['change']['type'] == 'rowSelection') {
      this.pickedRowIDs = [];
      this.pickedRowDisplayNames = [];
      this.pickedRowNumbers = [];
      this.clickedRows = gridStateChanges['detail']['change'].newValues['gridRowIndexes'];
      this.selectedRows = gridStateChanges['detail']['change'].newValues['filteredDataContextIds'];
      this.pickedRowNumbers = this.clickedRows;
      this.pickedRowIDs = this.selectedRows;
      this.onRowMultipleClicked();
    }
  }

  sortGrid(header, order) {
    this.sortBy(header.id, header.CosyDataTypeDID, order, this.ie, null);
  }

  highlightGridCell(c){
    let cellNo= this.angularGrid.gridService.getAllColumnDefinitions().map(function (e){return e.name}).indexOf(c.name);
    this.gridObj.gotoCell(0, cellNo, false);
  }

  onRowMultipleClicked() {
    if(this.ie.Attributes.OnMultiSelectUAID!= null){
      this.getDisplayNamesPerSelectedRows(this.selectedRows);
      this.uxControllerService.setActiveSelectedRows(this.pickedRowNumbers, this.pickedRowIDs, this.pickedRowDisplayNames);
      this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, this.selectedRows, null, null, null, this.formgroup, null);
    }
  }

  onRowSingleClicked(e: Event, args: any) {
    let rowID = '';
    if(this.ie.Attributes.OnMultiSelectUAID!= null){
      var row = this.angularGrid.dataView.getItem(args.row);
      this.pickedRowNumbers.push(args.row)
      this.pickedRowIDs.push(row.id);
      this.pickedRowNumbers = this.updateSelectedRowsOnMultiselect(this.pickedRowNumbers);
      this.pickedRowIDs = this.updateSelectedRowsOnMultiselect(this.pickedRowIDs);
      this.angularGrid.gridService.setSelectedRows(this.pickedRowNumbers);
      this.onRowMultipleClicked();
    }
    if (this.ie.Attributes.OnMultiSelectUAID == null) {
      this.pickedRowIDs = []; 
      this.pickedRowDisplayNames = [];
      let clickedRow = args.row;
      var row = this.angularGrid.dataView.getItem(args.row);
      this.pickedRowNumbers.push(clickedRow);
      this.pickedRowNumbers = this.updateSelectedRowsOnSingleselect(this.pickedRowNumbers);
      if(this.pickedRowNumbers.length == 1 && 
          ((this.initIE.Values.length == 0) ||
            (this.initIE.Values.length>0 && this.ie.Values.length> 0 && row.id !== this.initIE.Values[0].Value) )){
       row =  this.angularGrid.dataView.getItem(this.pickedRowNumbers[0]);
       this.pickedRowIDs.push(row['id']);
       this.pickedRowDisplayNames.push(row['displayName']);
       rowID = row['id'];
      }
      else {
        rowID = '';
        let colorCode ;
        if(clickedRow%2 == 0){
          colorCode =   '#FFFFFF';
        }
        else { colorCode = '#F7F7F7';}
        for(let c=0; c< this.columnDefinitions.length; c++){
          let cellNode = this.angularGrid.slickGrid.getCellNode(clickedRow, c);
          var $c = $(cellNode);
          $c.css('background-color', colorCode);
        }
      }

      this.uxControllerService.setActiveSelectedRows(this.pickedRowNumbers, this.pickedRowIDs, this.pickedRowDisplayNames);

      if(rowID == '' && this.ie.Attributes.OnUnSelectUAID!==  null){
        this.fetchIEUserAction(this.ie.Attributes.OnUnSelectUAID, rowID, null, null, null, this.formgroup, null);
      }else {
        this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, rowID, null, null, null, this.formgroup, null);
      }
    }
  }

  onRowDoubleClicked(e: Event, args: any) {
    let clickedRow = args.row;
    this.pickedRowNumbers = []; this.pickedRowIDs = []; this.pickedRowDisplayNames = [];
    this.angularGrid.gridService.setSelectedRows([clickedRow]);
    var row = this.angularGrid.dataView.getItem(args.row);
    this.pickedRowNumbers.push(clickedRow);
    this.pickedRowIDs.push(row.id);
    this.pickedRowDisplayNames.push(row.DisplayName);
    this.uxControllerService.setActiveSelectedRows(this.pickedRowNumbers, this.pickedRowIDs, this.pickedRowDisplayNames);
    this.fetchIEUserAction(this.ie.Attributes.OnDblClickUAID, row.id, null, null, null, this.formgroup, false);
  }

  onColClicked(args) {
    this.selectedColumn = args.args.column;
    if (this.ie.Attributes.OnColSelectUAID != null && this.selectedColumn.name !== '' && this.selectedColumn.id !== '_checkbox_selector') {

      for (let c = 0; c < this.columnDefinitions.length; c++) {
        if (this.columnDefinitions[c].id == this.selectedColumn.id) {
          this.setRowsPerColClick(c, '#dae8f1');
        }
      }
      this.fetchIEUserAction(this.ie.Attributes.OnColSelectUAID, this.selectedColumn.name, null, null, null, this.formgroup, null);
    }
  }

  onCellChanged(e: Event, args: any) { 
    this.isValidatorOn = false;
    console.log('args: ', args);
    let modifiedHeader = args['column'].id;
    let modifiedValue = args['item'][args['column'].id];
    if(args.column['cosyDataTypeID'] == InterfaceElementDataTypes.StringDT){
      if (this.isValidatorOn) this.isValidatorOn = false;
    }
    if(args.column['cosyDataTypeID'] == InterfaceElementDataTypes.DateDT){
      modifiedValue = modifiedValue.replaceAll('/','.');
      this.dataset[args.row][modifiedHeader] = modifiedValue;
      args.grid.invalidateAllRows();
      args.grid.render();
    }
    if(args.column['cosyDataTypeID'] == InterfaceElementDataTypes.PicklistDT){
      let items: any[] = [];
      items = args['column']['items']
      let modifiedIndex = items.map(function(e){return e.DisplayName}).indexOf(modifiedValue)
      modifiedValue = items[modifiedIndex]['ID']
      console.log('Items: ',args['column']['items']);
      console.log('ModifiedValue: ',modifiedValue);
    }
    
    
    this.updatedObject = args.item;
    let rowItem : RowItem = new RowItem();
    rowItem.ID = args['item'].id;
    let colItem: ColItem = new ColItem();
    colItem.Name = modifiedHeader;
    colItem.Value = modifiedValue;
    rowItem.ColItems = [];
    rowItem.ColItems.push(colItem);
   
    this.cosyCommunicationControllerService.postGridEditedData( this.cosyCommunicationControllerService.localSessionID,rowItem.ID ,this.ie.ObjectID,modifiedHeader,modifiedValue)
   // this.fetchIEUserAction('4e346849-88d9-42d4-982d-89881c66a4a0', rowItem, null, null, null, this.formgroup, false);
  }

  revertLastEdit() {
    const lastEdit = this.editQueue.pop();
    if (lastEdit) {
       lastEdit.undo();
       this.gridObj.gotoCell(lastEdit.row, lastEdit.cell, false);
    }
  }

  saveAllEdited() {
    // for example, to get the last Edit, you could type get it this way
    // const lastEdit = this.editQueue[this.editQueue.length - 1];
    // const lastEditField = lastEdit && lastEdit.column && lastEdit.column.field;
    const editItems = [];
    this.editQueue.forEach((editObj) => {
      const previousValue = editObj.prevSerializedValue;
      const newValue = editObj.serializedValue;
      const rowIndex = editObj.row; // from the row index, you can get the item
      const item = this.angularGrid.dataView.getItem(rowIndex);
      editItems.push(item);
    });
    this.editQueue = [];     
 }

  updateSelectedRowsOnMultiselect(rows){
    var duplicates = rows.reduce(function(acc, el, i, arr) {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
    }, []);
    rows = rows.filter((el, i, a) => i === a.indexOf(el))
    rows.forEach((element,index)=>{
      if(element==duplicates[0])  rows.splice(index,1);
    });

    return rows;
  }

  updateSelectedRowsOnSingleselect(rows){
    for(var r=1; r<rows.length; r++){
        if(rows[r]== rows[r-1]){
          let duplicateItem = rows[r];
          rows.splice(r, 1);
          let index = rows.map(function(e){return e}).indexOf(duplicateItem);
          rows.splice(index,1)
        } 
        else if(rows[r]!= rows[r-1]){
          let rIndex = r-1;
          rows.splice(rIndex, 1);    
        }
    }
    return rows;
  }

  setRowsPerColClick(colIndex, colorCode) {
    let cellNode;
    if (this.ie.Attributes.OnMultiSelectUAID != null) {
      colIndex = colIndex + 1;
    }
    for (let d = 0; d < this.dataset.length; d++) {
      cellNode = this.angularGrid.slickGrid.getCellNode(d, colIndex);
      var $c = $(cellNode);
      $c.css('background-color', colorCode);
    }
  }

  destroyGrid(shouldEmptyDomElementContainer = false) {
    if (this.dataviewObj) {
      if (this.dataviewObj?.setItems) {
        this.dataviewObj.setItems([]);
      }
      if (this.dataviewObj.destroy) {
        this.dataviewObj.destroy();
      }
    }
    if (this.angularGrid?.destroy) {
      this.angularGrid.destroy(shouldEmptyDomElementContainer);
    }
    for (const prop of Object.keys(this.columnDefinitions)) {
      (this.columnDefinitions as any)[prop] = null;
    }

    this.dataset = null;
    this.columnDefinitions = [];
    this.angularGrid.dataView.refresh();
    this.dataviewObj = null;
  }


  changeToNextPage(event: any) {
    this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, this.ie.Attributes.ActivePage + 1, 'ActivePage', null, null, null, null);
  }
  changeToFirstPage(event: any) {
    this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, 1, 'ActivePage', null, null, null, null);
  }
  changeToPreviousPage(event: any) {
    this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, this.ie.Attributes.ActivePage - 1, 'ActivePage', null, null, null, null);
  }
  changeToLastPage(event: any) {
    this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, this.ie.Attributes.PageCount, 'ActivePage', null, null, null, null);
  }
  changeToCurrentPage(event: any) {
    if (event.currentTarget.value <= this.ie.Attributes.PageCount && event.currentTarget.value > 0) {
      this.fetchIEUserAction(this.ie.Attributes.OnPagerUAID, event.currentTarget.value, 'ActivePage', null, null, null, null);
    }
    else {
      document.getElementById("activePage").style.color = "red";
    }
  }

  pageValidator(pageValue) {
    if (pageValue > this.ie.Attributes.PageCount || pageValue < 1) {
      document.getElementById("activePage").style.color = "red";
    }
    else {
      document.getElementById("activePage").style.color = "black";
    }
  }

  simulateServerAsyncCall(item: any) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const itemDetail = item;
        resolve(itemDetail);
      }, 10);
    });
  }

  public fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[], group: FormGroup, multiSelect: boolean) {
    this.uxControllerService.fetchUserAction(userActionID, this.ie, null, value, attributeKey, additionalAttributes, additionalAttributes, this.formgroup, multiSelect);
  }

  sortBy(term: any, dataTypeID: string, order: string, ieListType: InterfaceElement, evt: MouseEvent) {
    for (let ua of ieListType.UserActions) {
      if (ua.UserActionID == ieListType.Attributes.OnSortUAID) {

        if (ua.ActionProcessOnServer) {
          let addAttributes = [];
          addAttributes.push({ attribute: 'ActivePage', value: 1 });
          this.uxControllerService
            .fetchUserAction(ieListType.Attributes.OnSortUAID,
              ieListType,
              null,
              '[' + term + '] ' + order.toUpperCase(),
              'SortOrder',
              addAttributes,
              null,
              null,
              null)
        } else {

        }
      }
    }
  }

  calculateColumnWidth(header: HeaderItem) {
    let lw = 0;
    let hdw = (header.DisplayName.length * 8) + 52;
  
    if (this.ie.EntityList.RowItems.length > 0) {
      let indexCol = this.ie.EntityList.RowItems[0].ColItems.map(function (e) { return e.Name }).indexOf(header.Name);
      let rowItems = [];
      if (indexCol > -1) {
        for (let r of this.ie.EntityList.RowItems) {
          rowItems.push(r.ColItems[indexCol].Value);
        }
      }
      rowItems.push(header.DisplayName)
      lw = this.findLongestWord(rowItems);
      lw = (lw * 8) + 52
      if(header.Editable!== null && header.Editable){
        lw = lw+52;
      }
    }
    if (lw < hdw) {
      lw = hdw;
    }
  
    return lw;
  }
  downloadResource(rowID: string) {
    let documentID: string = this.ie.EntityList.RowItems.find(rowItem => rowItem.ID == rowID).ColItems.find(colItem => colItem.Name == this.resourceHeaderItem.Name).Value;
    this.cosyCommunicationControllerService.showNdownloadPDF(documentID).subscribe((res: any) => {
      const linkSource = 'data:application/pdf;base64,' + res['b64Data'];
      this.pdfURL = this.base64ToArrayBuffer(res['b64Data']);
      let blob = new Blob([this.pdfURL], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = res['fileName'];
      link.click();
    });
  }

  base64ToArrayBuffer(base64) {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  stopBubbling(evt) {
    if (evt != null) {
      evt.stopPropagation();
      evt.cancelBubble = true;
    }
  }
  findLongestWord(str) {
    let strSplit = str;
    if (str.length > 0) {
      var longestWord = strSplit.sort(function (a, b) {
        return b.length - a.length;
      });
      return longestWord[0].toString().length;
    } else {
      return 0;
    }
  }
}


